<div class="sari-metrics-wrapper">
  <app-error-alert *ngIf="showAlertError" [message]="errorMessage"></app-error-alert>

  <div class="main-card">
    <div class="upload-section">
      <h3 class="upload-label">Archivo CSV</h3>
      
      <!-- Drag & Drop Zone -->
      <div 
        class="drop-zone"
        [class.dragging]="isDragging"
        [class.has-file]="file"
        (dragover)="onDragOver($event)"
        (dragleave)="onDragLeave($event)"
        (drop)="onDrop($event)"
        (click)="triggerFileInput()"
        (keydown.enter)="triggerFileInput()"
        (keydown.space)="triggerFileInput()"
        tabindex="0"
        role="button"
        [attr.aria-label]="file ? 'Archivo seleccionado: ' + fileName + '. Haz clic para cambiar' : 'Haz clic o arrastra un archivo CSV aquí'">
        <input
          type="file"
          accept=".csv"
          class="upload-input-hidden"
          (change)="onFileSelected($event)"
          #fileInput />
        
        <div class="drop-zone-content">
          <svg *ngIf="!file" class="upload-icon" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12" />
          </svg>
          
          <svg *ngIf="file" class="file-icon" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
          </svg>
          
          <div class="drop-zone-text">
            <p class="drop-zone-title" *ngIf="!file">Arrastra tu archivo CSV aquí</p>
            <p class="drop-zone-title success" *ngIf="file">{{ fileName }}</p>
            <p class="drop-zone-subtitle" *ngIf="!file">o haz clic para seleccionar</p>
            <p class="drop-zone-subtitle" *ngIf="file">Haz clic para cambiar el archivo</p>
          </div>
        </div>
      </div>

      <div class="upload-actions">
        <button type="button" class="btn btn-primary" (click)="upload()" [disabled]="!file">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
          Procesar
        </button>
        <button type="button" class="btn btn-secondary" *ngIf="file" (click)="clearFile()">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
          </svg>
          Limpiar
        </button>
      </div>
    </div>

    <ng-container *ngIf="data">
      <div class="results-header">
        <div class="header-info">
          <div class="file-info">
            <svg class="info-icon" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
            </svg>
            <span class="file-name">{{ data.metadata.filename }}</span>
          </div>
          <div class="meta-info">
            <div class="date-info">
              <svg class="meta-icon" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
              </svg>
              <span class="date-label">Fecha generación reporte:</span>
              <span class="date-text">{{ currentDate | date:'dd/MM/yyyy HH:mm' }}</span>
            </div>
            <!-- <div class="total-info">
              <span class="total-badge">{{ data.total_general }} tickets analizados</span>
            </div> -->
          </div>
        </div>
        <button 
          type="button" 
          class="btn btn-export" 
          (click)="exportToPDF()"
          [disabled]="isExporting">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
          </svg>
          {{ isExporting ? 'Generando...' : 'Exportar PDF' }}
        </button>
      </div>

      <!-- Tabs de Períodos -->
      <div class="periodo-tabs">
        <button 
          *ngFor="let periodo of data.periodos; let i = index"
          type="button"
          class="periodo-tab"
          [class.active]="i === selectedPeriodoIndex"
          (click)="selectPeriodo(i)">
          <span class="periodo-tab-name">{{ formatPeriodoName(periodo.periodo) }}</span>
          <span class="periodo-tab-count">{{ periodo.total_records }} tickets</span>
        </button>
        <button 
          *ngIf="data.periodos.length === 2"
          type="button"
          class="periodo-tab periodo-tab-compare"
          [class.active]="viewMode === 'compare'"
          (click)="toggleViewMode()">
          <svg class="tab-icon" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
          </svg>
          <span class="periodo-tab-name">Comparar</span>
        </button>
      </div>

      <div #resultsContainer class="results-content" *ngIf="currentPeriodo && (viewMode === 'single' || isExportingAll)">
        <!-- Grid compacto: Estado y Categoría juntas -->
        <div class="metrics-grid">
          <section class="chart-section compact">
            <h3 class="section-title">
              <svg class="title-icon" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
              </svg>
              Tickets por estado
            </h3>
            <div class="bar-chart">
              <div *ngFor="let m of currentPeriodo.metrics_by_state" class="bar-row">
                <span class="bar-label">{{ m.estado }}</span>
                <div class="bar-track">
                  <div class="bar-fill" [style.width.%]="porcentajeNum(m.porcentaje)"></div>
                </div>
                <span class="bar-value">{{ m.total }} <span class="bar-percent">({{ m.porcentaje }})</span></span>
              </div>
              <div class="bar-row bar-total">
                <span class="bar-label-total">TOTAL</span>
                <div class="bar-track-total"></div>
                <span class="bar-value-total">{{ totalTicketsPorEstado }} <span class="bar-percent-total">({{ totalPorcentajePorEstado | number:'1.2-2' }}%)</span></span>
              </div>
            </div>
          </section>

          <section class="chart-section compact">
            <h3 class="section-title">
              <svg class="title-icon" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M7 7h.01M7 3h5c.512 0 1.024.195 1.414.586l7 7a2 2 0 010 2.828l-7 7a2 2 0 01-2.828 0l-7-7A1.994 1.994 0 013 12V7a4 4 0 014-4z" />
              </svg>
              Total por categoría
            </h3>
            <div class="bar-chart">
              <div *ngFor="let c of currentPeriodo.total_by_category" class="bar-row">
                <span class="bar-label" [title]="c.motivo_solicitud">{{ c.motivo_solicitud }}</span>
                <div class="bar-track">
                  <div class="bar-fill" [style.width.%]="porcentajeNum(c.porcentaje)"></div>
                </div>
                <span class="bar-value">{{ c.total }} <span class="bar-percent">({{ c.porcentaje }})</span></span>
              </div>
              <div class="bar-row bar-total">
                <span class="bar-label-total">TOTAL</span>
                <div class="bar-track-total"></div>
                <span class="bar-value-total">{{ totalTicketsPorCategoria }} <span class="bar-percent-total">({{ totalPorcentajePorCategoria | number:'1.2-2' }}%)</span></span>
              </div>
            </div>
          </section>
        </div>

      <!-- Horas por agente - tabla más compacta -->
      <section class="chart-section compact">
        <h3 class="section-title">
          <svg class="title-icon" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
          Resumen horas por agente
        </h3>
        <div class="table-wrap">
          <table class="data-table data-table-compact">
            <thead>
              <tr>
                <th>Agente</th>
                <th>Promedio h</th>
                <th>Tickets</th>
                <th>%</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let h of currentPeriodo.hours_by_agent">
                <td>{{ h.agente }}</td>
                <td>{{ h.promedio_horas | number:'1.1-1' }}</td>
                <td>{{ h.numero_tickets }}</td>
                <td>{{ h.porcentaje }}</td>
              </tr>
            </tbody>
            <tfoot>
              <tr class="total-row">
                <td><strong>TOTAL</strong></td>
                <td><strong>{{ totalPromedioHorasPorAgente | number:'1.1-1' }}</strong></td>
                <td><strong>{{ totalTicketsPorAgente }}</strong></td>
                <td><strong>{{ totalPorcentajePorAgente | number:'1.2-2' }}%</strong></td>
              </tr>
            </tfoot>
          </table>
        </div>
      </section>

      <!-- Motivo por agente - versión compacta -->
      <section class="chart-section compact">
        <h3 class="section-title">
          <svg class="title-icon" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
          </svg>
          Detalle por agente
        </h3>
        <div class="motivo-list">
          <div *ngFor="let a of currentPeriodo.motivo_por_agente" class="motivo-agente">
            <button type="button" class="motivo-agente-header" (click)="toggleAgente(a.agente)">
              <span class="toggle-icon">{{ expandedAgente === a.agente ? '▼' : '▶' }}</span>
              <span class="agente-name">{{ a.agente }}</span>
              <span class="motivo-agente-meta">{{ a.total_tickets }} tickets | Prom. h: {{ a.promedio_horas | number:'1.1-1' }}</span>
            </button>
            <div *ngIf="expandedAgente === a.agente || isExportingAll" class="motivo-desglose">
              <table class="data-table data-table-small">
                <thead>
                  <tr>
                    <th>Motivo</th>
                    <th>Prom. h</th>
                    <th>Total</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let d of a.desglose">
                    <td>{{ d.motivo_solicitud }}</td>
                    <td>{{ d.promedio_horas | number:'1.1-1' }}</td>
                    <td>{{ d.total }}</td>
                  </tr>
                </tbody>
                <tfoot>
                  <tr class="total-row">
                    <td><strong>PROMEDIO PONDERADO AGENTE</strong></td>
                    <td><strong>{{ a.promedio_horas | number:'1.1-1' }}</strong></td>
                    <td><strong>{{ getTotalTicketsDesglose(a.desglose) }}</strong></td>
                  </tr>
                </tfoot>
              </table>
            </div>
          </div>
          <div class="motivo-agente motivo-agente-total">
            <div class="motivo-agente-header motivo-total-row">
              <span class="agente-name"><strong>TOTAL</strong></span>
              <span class="motivo-agente-meta"><strong>{{ totalTicketsMotivoPorAgente }} tickets</strong></span>
            </div>
          </div>
        </div>
      </section>

      <!-- Análisis división - versión compacta -->
      <section class="chart-section compact">
        <h3 class="section-title">
          <svg class="title-icon" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 3.055A9.001 9.001 0 1020.945 13H11V3.055z" />
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M20.488 9H15V3.512A9.025 9.025 0 0120.488 9z" />
          </svg>
          Análisis división de tickets
        </h3>
        <div class="division-grid">
          <div class="division-block" *ngIf="currentPeriodo.analisis_division.por_area.length">
            <h4>Por área</h4>
            <div class="bar-chart bar-chart-compact">
              <div *ngFor="let e of currentPeriodo.analisis_division.por_area" class="bar-row">
                <span class="bar-label">{{ e.nombre }}</span>
                <div class="bar-track"><div class="bar-fill" [style.width.%]="porcentajeNum(e.porcentaje)"></div></div>
                <span class="bar-value">{{ e.total }} <span class="bar-percent">({{ e.porcentaje }})</span></span>
              </div>
              <div class="bar-row bar-total">
                <span class="bar-label-total">TOTAL</span>
                <div class="bar-track-total"></div>
                <span class="bar-value-total">{{ totalTicketsPorArea }} <span class="bar-percent-total">({{ totalPorcentajePorArea | number:'1.2-2' }}%)</span></span>
              </div>
            </div>
          </div>
          <div class="division-block">
            <h4>Por tipo</h4>
            <div class="bar-chart bar-chart-compact">
              <div *ngFor="let t of currentPeriodo.analisis_division.por_tipo" class="bar-row">
                <span class="bar-label">{{ t.nombre }}</span>
                <div class="bar-track"><div class="bar-fill" [style.width.%]="porcentajeNum(t.porcentaje)"></div></div>
                <span class="bar-value">{{ t.total }} <span class="bar-percent">({{ t.porcentaje }})</span></span>
              </div>
              <div class="bar-row bar-total">
                <span class="bar-label-total">TOTAL</span>
                <div class="bar-track-total"></div>
                <span class="bar-value-total">{{ totalTicketsPorTipo }} <span class="bar-percent-total">({{ totalPorcentajePorTipo | number:'1.2-2' }}%)</span></span>
              </div>
            </div>
          </div>
          <div class="division-block">
            <h4>Por prioridad</h4>
            <div class="bar-chart bar-chart-compact">
              <div *ngFor="let p of currentPeriodo.analisis_division.por_prioridad" class="bar-row">
                <span class="bar-label">{{ p.nombre }}</span>
                <div class="bar-track"><div class="bar-fill" [style.width.%]="porcentajeNum(p.porcentaje)"></div></div>
                <span class="bar-value">{{ p.total }} <span class="bar-percent">({{ p.porcentaje }})</span></span>
              </div>
              <div class="bar-row bar-total">
                <span class="bar-label-total">TOTAL</span>
                <div class="bar-track-total"></div>
                <span class="bar-value-total">{{ totalTicketsPorPrioridad }} <span class="bar-percent-total">({{ totalPorcentajePorPrioridad | number:'1.2-2' }}%)</span></span>
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- Cumplimiento por agente -->
      <section class="chart-section compact" *ngIf="currentPeriodo.cumplimiento_por_agente.length">
        <h3 class="section-title">
          <svg class="title-icon" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
          Cumplimiento por agente
        </h3>
        <div class="table-wrap">
          <table class="data-table data-table-compact">
            <thead>
              <tr>
                <th>Agente</th>
                <th>Total</th>
                <th>Cerrados</th>
                <th>Abiertos</th>
                <th>En gestión</th>
                <th>Cumplimiento</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let c of currentPeriodo.cumplimiento_por_agente">
                <td>{{ c.agente }}</td>
                <td>{{ c.tickets_totales }}</td>
                <td>{{ c.tickets_cerrados }}</td>
                <td>{{ c.tickets_abiertos }}</td>
                <td>{{ c.tickets_en_gestion }}</td>
                <td>
                  <div class="cumplimiento-cell">
                    <div class="cumplimiento-bar-track">
                      <div class="cumplimiento-bar-fill" [class]="cumplimientoClass(c.porcentaje_cumplimiento)" [style.width.%]="porcentajeNum(c.porcentaje_cumplimiento)"></div>
                    </div>
                    <span class="cumplimiento-value" [class]="cumplimientoClass(c.porcentaje_cumplimiento)">{{ c.porcentaje_cumplimiento }}</span>
                  </div>
                </td>
              </tr>
            </tbody>
            <tfoot>
              <tr class="total-row">
                <td><strong>TOTAL</strong></td>
                <td><strong>{{ totalCumplimientoTickets }}</strong></td>
                <td><strong>{{ totalCumplimientoCerrados }}</strong></td>
                <td><strong>{{ totalCumplimientoAbiertos }}</strong></td>
                <td><strong>{{ totalCumplimientoEnGestion }}</strong></td>
                <td>
                  <div class="cumplimiento-cell">
                    <div class="cumplimiento-bar-track">
                      <div class="cumplimiento-bar-fill" [class]="cumplimientoClass(totalPorcentajeCumplimiento + '%')" [style.width.%]="totalPorcentajeCumplimiento"></div>
                    </div>
                    <span class="cumplimiento-value" [class]="cumplimientoClass(totalPorcentajeCumplimiento + '%')"><strong>{{ totalPorcentajeCumplimiento | number:'1.1-1' }}%</strong></span>
                  </div>
                </td>
              </tr>
            </tfoot>
          </table>
        </div>
      </section>

      <!-- Entregables PDN por agente -->
      <section class="chart-section compact" *ngIf="currentPeriodo.entregables_pdn_por_agente?.length">
        <h3 class="section-title">
          <svg class="title-icon" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-6 9l2 2 4-4" />
          </svg>
          Entregables PDN por agente
        </h3>
        <div class="table-wrap">
          <table class="data-table data-table-compact">
            <thead>
              <tr>
                <th>Agente</th>
                <th>Total</th>
                <th>Cumplidos</th>
                <th>No cumplidos</th>
                <th>Cumplimiento</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let e of currentPeriodo.entregables_pdn_por_agente">
                <td>{{ e.agente }}</td>
                <td>{{ e.total_entregables }}</td>
                <td>{{ e.entregables_cumple }}</td>
                <td>{{ e.entregables_no_cumple }}</td>
                <td>
                  <div class="cumplimiento-cell">
                    <div class="cumplimiento-bar-track">
                      <div class="cumplimiento-bar-fill" [class]="cumplimientoClass(e.porcentaje_cumplimiento)" [style.width.%]="porcentajeNum(e.porcentaje_cumplimiento)"></div>
                    </div>
                    <span class="cumplimiento-value" [class]="cumplimientoClass(e.porcentaje_cumplimiento)">{{ e.porcentaje_cumplimiento }}</span>
                  </div>
                </td>
              </tr>
            </tbody>
            <tfoot>
              <tr class="total-row">
                <td><strong>TOTAL</strong></td>
                <td><strong>{{ totalEntregables }}</strong></td>
                <td><strong>{{ totalEntregablesCumple }}</strong></td>
                <td><strong>{{ totalEntregablesNoCumple }}</strong></td>
                <td>
                  <div class="cumplimiento-cell">
                    <div class="cumplimiento-bar-track">
                      <div class="cumplimiento-bar-fill" [class]="cumplimientoClass(totalPorcentajeCumplimientoEntregables + '%')" [style.width.%]="totalPorcentajeCumplimientoEntregables"></div>
                    </div>
                    <span class="cumplimiento-value" [class]="cumplimientoClass(totalPorcentajeCumplimientoEntregables + '%')"><strong>{{ totalPorcentajeCumplimientoEntregables | number:'1.1-1' }}%</strong></span>
                  </div>
                </td>
              </tr>
            </tfoot>
          </table>
        </div>
      </section>

      <!-- Top usuarios solicitantes -->
      <section class="chart-section compact" *ngIf="currentPeriodo.top_usuarios_solicitantes.length">
        <h3 class="section-title">
          <svg class="title-icon" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
          </svg>
          Top 10 usuarios solicitantes
        </h3>
        <div class="table-wrap">
          <table class="data-table data-table-compact">
            <thead>
              <tr>
                <th class="top-user-rank">#</th>
                <th>Usuario</th>
                <th>Tickets</th>
                <th>%</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let u of currentPeriodo.top_usuarios_solicitantes; let idx = index">
                <td class="top-user-rank">
                  <span class="rank-badge" [class.rank-1]="idx === 0" [class.rank-2]="idx === 1" [class.rank-3]="idx === 2">{{ idx + 1 }}</span>
                </td>
                <td>{{ u.nombre_contacto }}</td>
                <td>{{ u.total_tickets }}</td>
                <td>{{ u.porcentaje }}</td>
              </tr>
            </tbody>
            <tfoot>
              <tr class="total-row">
                <td></td>
                <td><strong>TOTAL TOP 10</strong></td>
                <td><strong>{{ totalTopUsuariosTickets }}</strong></td>
                <td><strong>{{ totalTopUsuariosPorcentaje | number:'1.1-1' }}%</strong></td>
              </tr>
            </tfoot>
          </table>
        </div>
      </section>

      <!-- Tickets por área -->
      <section class="chart-section compact" *ngIf="currentPeriodo.tickets_por_area.length">
        <h3 class="section-title">
          <svg class="title-icon" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
          </svg>
          Tickets por área
        </h3>
        <div class="bar-chart">
          <div *ngFor="let a of currentPeriodo.tickets_por_area" class="bar-row">
            <span class="bar-label">{{ a.area }}</span>
            <div class="bar-track">
              <div class="bar-fill" [style.width.%]="porcentajeNum(a.porcentaje)"></div>
            </div>
            <span class="bar-value">{{ a.total_tickets }} <span class="bar-percent">({{ a.porcentaje }})</span></span>
          </div>
          <div class="bar-row bar-total">
            <span class="bar-label-total">TOTAL</span>
            <div class="bar-track-total"></div>
            <span class="bar-value-total">{{ totalTicketsPorAreaNew }} <span class="bar-percent-total">({{ totalPorcentajePorAreaNew | number:'1.1-1' }}%)</span></span>
          </div>
        </div>
      </section>

      <!-- Mapa de calor -->
      <section class="chart-section compact">
        <h3 class="section-title">
          <svg class="title-icon" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 5a1 1 0 011-1h14a1 1 0 011 1v2a1 1 0 01-1 1H5a1 1 0 01-1-1V5zM4 13a1 1 0 011-1h6a1 1 0 011 1v6a1 1 0 01-1 1H5a1 1 0 01-1-1v-6zM16 13a1 1 0 011-1h2a1 1 0 011 1v6a1 1 0 01-1 1h-2a1 1 0 01-1-1v-6z" />
          </svg>
          Mapa de calor - Tickets por día y hora
        </h3>
        <div class="heatmap-wrap">
          <table class="heatmap-table">
            <thead>
              <tr>
                <th rowspan="2" class="heatmap-header-main">DÍA</th>
                <th [attr.colspan]="currentPeriodo.mapa_calor.horas.length" class="heatmap-header-hours">HORAS</th>
                <th rowspan="2" class="heatmap-total">Total general</th>
              </tr>
              <tr>
                <th *ngFor="let hora of currentPeriodo.mapa_calor.horas" class="heatmap-hour">{{ hora }}</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let dia of currentPeriodo.mapa_calor.dias_semana; let i = index">
                <td class="heatmap-row-label">{{ dia }}</td>
                <td *ngFor="let hora of currentPeriodo.mapa_calor.horas; let jIdx = index"
                    [style.background-color]="heatColor(currentPeriodo.mapa_calor.matriz[i][jIdx])"
                    [class]="heatTextClass(currentPeriodo.mapa_calor.matriz[i][jIdx])">
                  {{ currentPeriodo.mapa_calor.matriz[i][jIdx] || '' }}
                </td>
                <td class="heatmap-total">{{ currentPeriodo.mapa_calor.totales_por_fila[i] }}</td>
              </tr>
              <tr class="heatmap-footer">
                <td class="heatmap-footer-label">Total general</td>
                <td *ngFor="let col of currentPeriodo.mapa_calor.totales_por_columna" class="heatmap-footer-value">{{ col }}</td>
                <td class="heatmap-total">{{ currentPeriodo.mapa_calor.total_general }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="heatmap-legend">
          <span class="legend-label">Intensidad:</span>
          <div class="legend-gradient">
            <span>Bajo</span>
            <div class="gradient-bar"></div>
            <span>Alto</span>
          </div>
        </div>
      </section>
      </div>

      <!-- Vista de Comparación -->
      <div #comparisonContainer class="results-content comparison-view" *ngIf="data.periodos.length === 2 && (viewMode === 'compare' || isExportingAll)">
        <section class="comparison-categories-chart" *ngIf="hasTotalesMensualesPorCategoria">
          <h3 class="section-title">
            <svg class="title-icon" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 17v-6m4 6V7m4 10v-3M3 4h18M4 4h16v16H4V4z" />
            </svg>
            Comparativo mensual por categoría
          </h3>
          <p class="comparison-categories-subtitle">Activa o desactiva categorías desde la leyenda superior para filtrar las barras por mes.</p>
          <div class="comparison-categories-chart-wrapper">
            <div #categoryComparisonChart class="comparison-categories-chart-canvas"></div>
          </div>
        </section>

        <div class="comparison-grid">
          <!-- Período 1 -->
          <div class="comparison-column">
            <h3 class="comparison-header">{{ formatPeriodoName(data.periodos[0].periodo) }}</h3>
            <div class="comparison-cards">
              <div class="comparison-card">
                <span class="card-label">Total Tickets</span>
                <span class="card-value">{{ data.periodos[0].total_records }}</span>
              </div>
              <div class="comparison-card">
                <span class="card-label">Tasa Cierre</span>
                <span class="card-value">{{ getTasaCierre(data.periodos[0]) }}%</span>
              </div>
              <div class="comparison-card">
                <span class="card-label">Agentes Activos</span>
                <span class="card-value">{{ data.periodos[0].hours_by_agent.length }}</span>
              </div>
            </div>
            
            <div class="comparison-section">
              <h4>Top 5 Categorías</h4>
              <div class="comparison-list">
                <div *ngFor="let c of data.periodos[0].total_by_category.slice(0, 5)" class="comparison-item">
                  <span class="item-label">{{ c.motivo_solicitud }}</span>
                  <span class="item-value">{{ c.total }} ({{ c.porcentaje }})</span>
                </div>
              </div>
            </div>

            <div class="comparison-section">
              <h4>Estados</h4>
              <div class="comparison-list">
                <div *ngFor="let s of data.periodos[0].metrics_by_state" class="comparison-item">
                  <span class="item-label">{{ s.estado }}</span>
                  <span class="item-value">{{ s.total }} ({{ s.porcentaje }})</span>
                </div>
              </div>
            </div>
          </div>

          <!-- Separador -->
          <div class="comparison-divider">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M7 16V4m0 0L3 8m4-4l4 4m6 0v12m0 0l4-4m-4 4l-4-4" />
            </svg>
          </div>

          <!-- Período 2 -->
          <div class="comparison-column">
            <h3 class="comparison-header">{{ formatPeriodoName(data.periodos[1].periodo) }}</h3>
            <div class="comparison-cards">
              <div class="comparison-card">
                <span class="card-label">Total Tickets</span>
                <span class="card-value">{{ data.periodos[1].total_records }}</span>
                <span class="card-diff" [class.positive]="data.periodos[1].total_records > data.periodos[0].total_records"
                      [class.negative]="data.periodos[1].total_records < data.periodos[0].total_records">
                  {{ getDifference(data.periodos[0].total_records, data.periodos[1].total_records) }}
                </span>
              </div>
              <div class="comparison-card">
                <span class="card-label">Tasa Cierre</span>
                <span class="card-value">{{ getTasaCierre(data.periodos[1]) }}%</span>
                <span class="card-diff" [class.positive]="getTasaCierre(data.periodos[1]) > getTasaCierre(data.periodos[0])"
                      [class.negative]="getTasaCierre(data.periodos[1]) < getTasaCierre(data.periodos[0])">
                  {{ getDifferenceDecimal(getTasaCierre(data.periodos[0]), getTasaCierre(data.periodos[1])) }}
                </span>
              </div>
              <div class="comparison-card">
                <span class="card-label">Agentes Activos</span>
                <span class="card-value">{{ data.periodos[1].hours_by_agent.length }}</span>
                <span class="card-diff" [class.positive]="data.periodos[1].hours_by_agent.length > data.periodos[0].hours_by_agent.length"
                      [class.negative]="data.periodos[1].hours_by_agent.length < data.periodos[0].hours_by_agent.length">
                  {{ getDifference(data.periodos[0].hours_by_agent.length, data.periodos[1].hours_by_agent.length) }}
                </span>
              </div>
            </div>
            
            <div class="comparison-section">
              <h4>Top 5 Categorías</h4>
              <div class="comparison-list">
                <div *ngFor="let c of data.periodos[1].total_by_category.slice(0, 5)" class="comparison-item">
                  <span class="item-label">{{ c.motivo_solicitud }}</span>
                  <span class="item-value">{{ c.total }} ({{ c.porcentaje }})</span>
                </div>
              </div>
            </div>

            <div class="comparison-section">
              <h4>Estados</h4>
              <div class="comparison-list">
                <div *ngFor="let s of data.periodos[1].metrics_by_state" class="comparison-item">
                  <span class="item-label">{{ s.estado }}</span>
                  <span class="item-value">{{ s.total }} ({{ s.porcentaje }})</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Comparación de Mapas de Calor por Semana -->
        <section class="chart-section compact comparison-heatmap-section">
          <h3 class="section-title">
            <svg class="title-icon" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 5a1 1 0 011-1h14a1 1 0 011 1v2a1 1 0 01-1 1H5a1 1 0 01-1-1V5zM4 13a1 1 0 011-1h6a1 1 0 011 1v6a1 1 0 01-1 1H5a1 1 0 01-1-1v-6zM16 13a1 1 0 011-1h2a1 1 0 011 1v6a1 1 0 01-1 1h-2a1 1 0 01-1-1v-6z" />
            </svg>
            Comparación de Mapas de Calor por Semana
          </h3>

          <!-- Resumen Semanal -->
          <div class="weekly-summary-grid">
            <div class="weekly-summary-card" *ngFor="let p of data.periodos; let i = index">
              <h4 class="weekly-summary-title">{{ formatPeriodoName(p.periodo) }}</h4>
              <div class="weekly-stats">
                <div class="weekly-stat">
                  <span class="weekly-stat-label">Promedio semanal</span>
                  <span class="weekly-stat-value">{{ getWeeklyAverage(p) | number:'1.0-0' }} tickets</span>
                </div>
                <div class="weekly-stat">
                  <span class="weekly-stat-label">Día más activo</span>
                  <span class="weekly-stat-value capitalize">{{ getPeakDay(p).day }} ({{ getPeakDay(p).total }})</span>
                </div>
                <div class="weekly-stat">
                  <span class="weekly-stat-label">Hora pico</span>
                  <span class="weekly-stat-value">{{ getPeakHour(p).hour }}:00 ({{ getPeakHour(p).total }})</span>
                </div>
                <div class="weekly-stat">
                  <span class="weekly-stat-label">Total mes</span>
                  <span class="weekly-stat-value">{{ p.total_records }} tickets</span>
                </div>
              </div>
            </div>
          </div>

          <!-- Comparación por día de la semana -->
          <div class="day-comparison">
            <h4 class="day-comparison-title">Tickets por día de la semana</h4>
            <div class="day-comparison-chart">
              <div *ngFor="let d of getDayComparisonData()" class="day-comparison-row">
                <span class="day-comparison-label">{{ d.day }}</span>
                <div class="day-comparison-bars">
                  <div class="day-bar-container">
                    <div class="day-bar day-bar-1" [style.width.%]="d.pct1"></div>
                    <span class="day-bar-value">{{ d.total1 }}</span>
                  </div>
                  <div class="day-bar-container">
                    <div class="day-bar day-bar-2" [style.width.%]="d.pct2"></div>
                    <span class="day-bar-value">{{ d.total2 }}</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="day-comparison-legend">
              <span class="legend-item"><span class="legend-color legend-color-1"></span>{{ formatPeriodoName(data.periodos[0].periodo) }}</span>
              <span class="legend-item"><span class="legend-color legend-color-2"></span>{{ formatPeriodoName(data.periodos[1].periodo) }}</span>
            </div>
          </div>

          <!-- Comparación por hora -->
          <div class="day-comparison">
            <h4 class="day-comparison-title">Distribución por hora del día</h4>
            <div class="hour-comparison-chart">
              <div *ngFor="let h of getHourComparisonData()" class="hour-comparison-col">
                <div class="hour-bars-wrapper">
                  <div class="hour-bar hour-bar-1" [style.height.%]="h.pct1" [title]="formatPeriodoName(data.periodos[0].periodo) + ': ' + h.total1"></div>
                  <div class="hour-bar hour-bar-2" [style.height.%]="h.pct2" [title]="formatPeriodoName(data.periodos[1].periodo) + ': ' + h.total2"></div>
                </div>
                <span class="hour-label">{{ h.hour }}</span>
              </div>
            </div>
            <div class="day-comparison-legend">
              <span class="legend-item"><span class="legend-color legend-color-1"></span>{{ formatPeriodoName(data.periodos[0].periodo) }}</span>
              <span class="legend-item"><span class="legend-color legend-color-2"></span>{{ formatPeriodoName(data.periodos[1].periodo) }}</span>
            </div>
          </div>

          <!-- Mapa de Calor Semanal Comparativo -->
          <div class="weekly-heatmaps-grid">
            <div class="weekly-heatmap-col" *ngFor="let p of data.periodos">
              <h4 class="weekly-heatmap-title">
                {{ formatPeriodoName(p.periodo) }}
                <span class="heatmap-col-total">({{ p.mapa_calor.total_general }} tickets)</span>
              </h4>
              <div class="heatmap-wrap">
                <table class="heatmap-table heatmap-table-weekly">
                  <thead>
                    <tr>
                      <th class="heatmap-header-main">SEMANA</th>
                      <th>Lun</th>
                      <th>Mar</th>
                      <th>Mié</th>
                      <th>Jue</th>
                      <th>Vie</th>
                      <th>Sáb</th>
                      <th>Dom</th>
                      <th class="heatmap-total">Total</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let week of getWeeklyDistribution(p)"
                        [class.week-partial]="week.isPartial"
                        [class.week-most-active]="week.isMostActive">
                      <td class="heatmap-row-label">{{ week.label }}</td>
                      <td *ngFor="let dayVal of week.days"
                          [style.background-color]="weeklyHeatColor(dayVal)"
                          [class]="weeklyHeatTextClass(dayVal)">
                        {{ dayVal || '' }}
                      </td>
                      <td class="heatmap-total" [class.most-active-total]="week.isMostActive">
                        {{ week.total }}
                      </td>
                    </tr>
                  </tbody>
                  <tfoot>
                    <tr class="heatmap-footer">
                      <td class="heatmap-footer-label">Total</td>
                      <td *ngFor="let dayTotal of p.mapa_calor.totales_por_fila" class="heatmap-footer-value">{{ dayTotal }}</td>
                      <td class="heatmap-total">{{ p.mapa_calor.total_general }}</td>
                    </tr>
                  </tfoot>
                </table>
              </div>
            </div>
          </div>

          <div class="heatmap-legend">
            <span class="legend-label">Intensidad (escala unificada):</span>
            <div class="legend-gradient">
              <span>Bajo</span>
              <div class="gradient-bar"></div>
              <span>Alto</span>
            </div>
            <span class="legend-separator">|</span>
            <span class="legend-item-inline">
              <span class="legend-active-marker"></span>
              Semana más activa
            </span>
          </div>
        </section>
      </div>
    </ng-container>
  </div>
</div>
